module.exports = __webpack_public_path__ + "img/ReplaceNRIBannerinExpertView (2).d2c7c67b.png";